import User from "@/inside/models/User";

/**
 * @param {[string, object]} entry1
 * @param {[string, object]} entry2
 * @param {string} key_prefix
 */
function compareEntries(entry1, entry2, key_prefix) {
    const entry1Lang = entry1[0];
    const entry1AdditionalStrings = entry1[1];
    const entry2Lang = entry2[0];
    const entry2AdditionalStrings = entry2[1];

    Object.entries(entry1AdditionalStrings).forEach((additional_string_entry) => {
        const additionalStringKey = additional_string_entry[0];
        const additionalStringValue = additional_string_entry[1];

        if (!Object.prototype.hasOwnProperty.call(entry2AdditionalStrings, additionalStringKey)) {
            console.warn(`[i18n] Key <${key_prefix}${additionalStringKey}> found in <${entry1Lang}> not found for lang <${entry2Lang}>`);
            return;
        }

        if (typeof additionalStringValue === "object") {
            compareEntries(
                [entry1Lang, additionalStringValue],
                [entry2Lang, entry2AdditionalStrings[additionalStringKey]],
                `${key_prefix}${additionalStringKey}.`
            );
        }
    });
}

/**
 * Scans for missing keys in additional strings.
 * @param {object} additional_strings_by_language_code
 * @param {string} prefix
 * @return {void}
 */
function scan(additional_strings_by_language_code, prefix) {
    prefix = typeof prefix === "string" ? prefix.trim() : "";
    Object.entries(additional_strings_by_language_code).forEach((entry1) => {
        const scannedLang = entry1[0];
        const scannedLangAdditionalStrings = entry1[1];

        Object.entries(additional_strings_by_language_code).forEach((entry2) => {
            const candidateLang = entry2[0];
            const candidateLangAdditionalStrings = entry2[1];
            compareEntries([
                scannedLang,
                scannedLangAdditionalStrings
            ], [
                candidateLang,
                candidateLangAdditionalStrings
            ], prefix !== "" ? `${prefix}.` : "");
        });
    });
}

export default {
    /**
     * @param Vue
     * @param {{debug: boolean, lang: string}} options
     * @return {void}
     */
    install(Vue, options) {
        options = Object.assign({
            debug: false,
            lang: navigator.language.slice(0, 2)
        }, typeof options === "object" ? options : {});

        if (!User.allowedLanguages.includes(options.lang)) {
            options.lang = "en";
        }

        /**
         * @type {{strings(object, string): object, lang: string}}
         */
        Vue.prototype.$i18n = {
            lang: options.lang,
            strings(additional_strings_by_language_code, debug_scan_prefix) {
                if (typeof additional_strings_by_language_code !== "object") {
                    throw new TypeError(`Vue plugin '$i18n.strings()' method expects parameter 1 to be an object, ${typeof additional_strings_by_language_code} given`);
                }

                if (options.debug) {
                    try {
                        scan(additional_strings_by_language_code, debug_scan_prefix);
                    } catch(e) {
                        console.error(`Debug scan failed (${e})`);
                    }
                }

                const additionalStrings = (Object.prototype.hasOwnProperty.call(
                    additional_strings_by_language_code,
                    options.lang
                ) ? additional_strings_by_language_code[options.lang] : {});

                return Object.freeze(Object.assign({
                    de: {
                        _cancel: "Abbrechen",
                        _dateFormat: "dd/MM/yyyy",
                        _datetimeFormat: "dd/MM/yyyy HH:mm",
                        _delete: "Löschen",
                        _error: "Ein Fehler ist aufgetreten",
                        _loading: "Laden",
                        _save: "Speichern"
                    },
                    en: {
                        _cancel: "Cancel",
                        _dateFormat: "MM/dd/yyyy",
                        _datetimeFormat: "MM/dd/yyyy HH:mm",
                        _delete: "Delete",
                        _error: "An error occurred",
                        _loading: "Loading",
                        _save: "Save"
                    },
                    fr: {
                        _cancel: "Annuler",
                        _dateFormat: "dd/MM/yyyy",
                        _datetimeFormat: "dd/MM/yyyy HH:mm",
                        _delete: "Supprimer",
                        _error: "Une erreur est survenue",
                        _loading: "Chargement",
                        _save: "Enregistrer"
                    }
                }[options.lang], additionalStrings));
            }
        };
    }
}
